import { render, staticRenderFns } from "./detailProgramOfficer.vue?vue&type=template&id=125d28ed&scoped=true"
import script from "./detailProgramOfficer.vue?vue&type=script&lang=js"
export * from "./detailProgramOfficer.vue?vue&type=script&lang=js"
import style0 from "./detailProgramOfficer.vue?vue&type=style&index=0&id=125d28ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d28ed",
  null
  
)

export default component.exports